import { render, staticRenderFns } from "./BaseContainer.vue?vue&type=template&id=4e4f1ae6&scoped=true"
import script from "./BaseContainer.vue?vue&type=script&lang=ts"
export * from "./BaseContainer.vue?vue&type=script&lang=ts"
import style0 from "./BaseContainer.vue?vue&type=style&index=0&id=4e4f1ae6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4f1ae6",
  null
  
)

export default component.exports